import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=3b1c56e5"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=3b1c56e5&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1c56e5')) {
      api.createRecord('3b1c56e5', component.options)
    } else {
      api.reload('3b1c56e5', component.options)
    }
    module.hot.accept("./ServiceCard.vue?vue&type=template&id=3b1c56e5", function () {
      api.rerender('3b1c56e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ServiceCard.vue"
export default component.exports